export const CITY_NAMES = [
  'LAHORE',
  'KARACHI',
  'ISLAMABAD',
  'RAWALPINDI',
  'DALLAS',
  'RIYADH',
  'DUBAI',
];

export const CITY_CENTERS = {
  lahore: { lat: 31.5497, lng: 74.3436 },
  karachi: { lat: 24.8607, lng: 67.0011 },
  riyadh: { lat: 24.7136, lng: 46.6753 },
  dubai: { lat: 25.2048, lng: 55.2708 },
};
